'use client'
import React, { useContext, useState } from 'react'
import Image from 'next/future/image'
import styles from './style.module.scss'
import F1Heading from '../F1Heading'
import ViewAll from '../widgets/ViewAllBtn'
import Experience from './experience'
import CustomLink from '@shared/components/customLink'
import PropTypes from 'prop-types'
import cars from './cars.json'
import GlobalEventsContext from '@shared/components/global-events/GlobalEventsContext'

// Assets
import moveNext from '@assets/images/f1/icons/nextButton.png'

const DriverInfo = ({ name, flag }) => (
  <div className="d-flex flex-column align-items-center gap-2">
    <p className={styles.flag}>{flag}</p>
    <span className={styles.driver}>{name}</span>
  </div>
)

DriverInfo.propTypes = {
  name: PropTypes.string,
  flag: PropTypes.string
}

const KnowYourCars = () => {
  const [activeIndex, setActiveIndex] = useState(0)

  const handleNext = () => {
    setActiveIndex((prev) => (prev + 1) % cars.length)
  }

  const data = cars[activeIndex]
  const { stateGlobalEvents } = useContext(GlobalEventsContext)

  return (
    <div className={styles.bg}>
      <div className={styles.carsLayout}>
        <div className="d-flex flex-row justify-content-between align-items-center">
          <F1Heading title="Know The Cars" />
          <div className="d-md-flex d-none">
            <ViewAll title="See All" href="/formula1-racing/teams" />
          </div>
        </div>

        <div className={styles.data}>
          <div className={styles.brandData}>
            {stateGlobalEvents?.darkModeEna === 'dark' ? <h2 className={styles.teamName}>{data?.teamName}</h2> : (
              <Image src={data?.brandLogo} alt="brand logo" width={260} height={0} className={styles.logo} />
            )}
            <p className={styles.para}>{data?.brandDescription}</p>

            <div className={styles.address}>
              <div>Engine <span className={styles.value}>{data?.cars?.engine}</span></div>
              <div>Chassis <span className={styles.value}>{data?.cars?.chassis}</span></div>
              <div>Power Unit <span className={styles.value}>{data?.cars?.powerUnit}</span></div>
              <div>Drivers <span className={styles.value}>{`${data?.cars?.driver[0]?.name}, ${data?.cars?.driver[1]?.name}`}</span></div>
              <div>Weight <span className={styles.value}>{data?.cars?.weight}</span></div>
            </div>

            <div className={styles.driversData}>
              <div className="d-flex flex-row justify-content-between">
                {data?.cars?.driver.map((driver, i) => (
                  <DriverInfo name={driver?.name} key={i} flag={driver?.countryFlag} />
                ))}
              </div>
              <Image src={data?.driversImg} alt="Drivers" width={510} height={300} />
            </div>
          </div>

          <div className={styles.imgData}>
            <div className="d-flex flex-column align-items-center">
              <Image src={data?.carsImg} alt="Car" height={698} width={400} className={styles.car} />
              <Experience year={data?.yearsOfExperience} race={data?.racesCover} />
            </div>
            <Image
              src={moveNext}
              alt="Next"
              height={70}
              width={70}
              className="cursor-pointer"
              onClick={handleNext}
            />
          </div>
        </div>

        <div className={styles.mwebData}>
          <h3 className='text-center'>{data?.teamName}</h3>
          <div className={styles.carContainer}>
            <div className={styles.carWrapper}>
              <Image src={data?.carsImg} alt="Car" height={301} width={140} className={styles.car} />
            </div>
            <Image
              src={moveNext}
              alt="Next"
              height={50}
              width={50}
              className={`${styles.moveNext} cursor-pointer`}
              onClick={handleNext}
            />
          </div>

          <p className={styles.para}>{data?.brandDescription}</p>

          <CustomLink href="/formula1-racing/teams">
            <div className={styles.learnMoreBTN}>
              See All
            </div>
          </CustomLink>

          <div className={styles.driversData}>
            <div className="d-flex flex-row justify-content-between">
              {data?.cars?.driver.map((driver, i) => (
                <DriverInfo name={driver?.name} key={i} flag={driver?.countryFlag} />
              ))}
            </div>
            <Image src={data?.driversImg} alt="Drivers" width={510} height={200} />
          </div>

          <Experience year={data?.yearsOfExperience} race={data?.racesCover} />
        </div>
      </div>

      {/* <div className={styles.learnMore}>
        <button className={styles.learnMoreBtn}>Learn More →</button>
        <p className={styles.learnMorePara}>
          While we strive to provide results nothing short of perfection, just as important is ensuring we act alongside our core values.
        </p>
      </div> */}
    </div>
  )
}

export default KnowYourCars
